<template>
  <div>
    <VueSignaturePad
      id="signature-pad"
      ref="signaturePad"
    />
    <div class="buttons-wrapper">
      <el-button
        type="info"
        @click="undo"
      >
        Undo
      </el-button>
      <el-button
        type="danger"
        @click="clear"
      >
        Clear
      </el-button>
      <el-button
        type="primary"
        @click="saveSignature"
      >
        Save
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignaturePad',
  props: {
    signature: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    base64: ''
  }),
  watch: {
    base64: function (value) {
      this.$emit('update:signature', value);
    }
  },
  methods: {
    undo () {
      this.$refs.signaturePad.undoSignature();
    },
    clear () {
      this.$refs.signaturePad.clearSignature();
    },
    saveSignature () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.base64 = data;
      } else {
        this.$message.warning('Signature can\'t be empty');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#signature-pad {
  border: solid 1px #000000;
  border-radius: 5px;
}

.buttons-wrapper {
  margin-top: 10px;

  button {
    margin-left: 5px;
  }
}
</style>
